/**
 * 餐饮服务
 */
import http from '../http';
import Qs from 'qs';

// 登录
// const handelLogin = (params) => http.post('/login', Qs.stringify(params)).then(res => res.data);

// 餐饮服务订单列表
const getfoodOrgOrderPage = params =>
  http.get('/userOrder/foodOrgOrderPage', { params }).then(res => res.data);
// 餐饮服务退款订单列表
const getfoodOrgRefundOrderPage = params =>
  http
    .get('/userOrder/foodOrgRefundOrderPage', { params })
    .then(res => res.data);
// 订餐退款
const refundFood = params =>
  http
    .post('/userOrder/refundFood', Qs.stringify(params))
    .then(res => res.data);
// 查询餐段信息
const getmealperiods = params =>
  http.get('/mealperiods', { params }).then(res => res.data);
// 新增餐段信息接口
const addMealperiods = params =>
  http({
    method: 'post',
    url: '/mealperiods',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 修改餐段信息接口
const editMealperiods = params =>
  http({
    method: 'put',
    url: `/mealperiods`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 删除餐段接口
const deleteMealperiods = params =>
  http.delete('/mealperiods', { params }).then(res => res.data);

// 查询菜品信息
const getdishinfos = params =>
  http.get('/dishinfos', { params }).then(res => res.data);
const getdishinfosUndish = params =>
  http.get(`/dailysupplyinfos/dishinfos`, { params }).then(res => res.data);
// 新增菜品信息接口
const adddishinfos = params =>
  http({
    method: 'post',
    url: '/dishinfos',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 修改菜品信息接口
const editdishinfos = params =>
  http({
    method: 'put',
    url: `/dishinfos`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 删除菜品信息接口
const deletedishinfos = params =>
  http.delete('/dishinfos', { params }).then(res => res.data);

// 查询日配餐信息
const getDailysupplyinfos = params =>
  http.get('/dailysupplyinfos', { params }).then(res => res.data);
// 新增日配餐信息接口
const addDailysupplyinfos = params =>
  http({
    method: 'post',
    url: `/dailysupplyinfos/${params.orgId}/${params.mealId}`,
    data: params.arr,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 删除菜品信息接口
const deleteSupplymealinfost = params =>
  http.delete('/supplymealinfost', { params }).then(res => res.data);
// 根据配餐id查询配餐信息-wx
const getSupplyMealById = params =>
  http
    .get('/supplymealinfos/getSupplyMealById', { params })
    .then(res => res.data);
// 导出明细
const exportExcel = params =>
  http.get('/insOfferDetail/export', { params }).then(res => res.data);

// 新增配餐信息接口-发布日配餐
const supplymealinfos = params =>
  http({
    method: 'post',
    url: '/supplymealinfos',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 修改配餐信息接口-修改日配餐
const updateQrysuppmealList = params =>
  http({
    method: 'put',
    url: `/supplymealinfos`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);

// 分页查询日配餐列表
const getQrysuppmealList = params =>
  http
    .get('/supplymealinfos/qrysuppmeal/page', { params })
    .then(res => res.data);

// 订餐详情
const getInsOfferDetail = params =>
  http.get('/insOfferDetail', { params }).then(res => res.data);

// 配餐订餐收入统计
const mealRevenueStatistics = params =>
  http
    .get('/insoffers/mealRevenueStatistics', { params })
    .then(res => res.data);
// 配餐订餐数量统计
const mealNumberStatistics = params =>
  http.get('/insoffers/mealNumberStatistics', { params }).then(res => res.data);

// 查询学生订餐信息
const qrystuordmeal = params =>
  http.get('/insoffers/qrystuordmeal', { params }).then(res => res.data);

// 获取上传token
const getUploadtoken = params =>
  http.get('/file/upload/token', { params }).then(res => res.data);

// 获取上传token
const getDownloadtoken = params =>
  http({
    method: 'post',
    url: '/file/down/token',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);
// 获取文件url
const getFileurl = params =>
  http.get('/file/url', { params }).then(res => res.data);
// 上传文件
const uploadFile = params =>
  http
    .post('', params, {
      baseURL: 'http://upload.gzhtoa.cn:82',
      withCredentials: false,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(res => res.data);

// 获取分店
const getBranch = params =>
  http
    .get('/sysOrganizationBranchs/orgBranch', { params })
    .then(res => res.data);

// 获取服务成员列表
const getOperatorList = params =>
  http.get('/sysOperators/operatorList', { params }).then(res => res.data);

// 没有发布的订餐列表列表
const listUnPubBySchool = params =>
  http
    .get('/supplymealinfos/listUnPubBySchool', { params })
    .then(res => res.data);
// 按批次发布(发布日配餐)
const publishPc = params =>
  http
    .post('/supplymealinfos/publish', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

export default {
  getfoodOrgOrderPage,
  getmealperiods,
  addMealperiods,
  editMealperiods,
  deleteMealperiods,
  getdishinfos,
  adddishinfos,
  editdishinfos,
  deletedishinfos,
  getUploadtoken,
  getDownloadtoken,
  getFileurl,
  uploadFile,
  getBranch,
  getOperatorList,
  getfoodOrgRefundOrderPage,
  refundFood,
  getDailysupplyinfos,
  addDailysupplyinfos,
  qrystuordmeal,
  supplymealinfos,
  getQrysuppmealList,
  getInsOfferDetail,
  getSupplyMealById,
  updateQrysuppmealList,
  deleteSupplymealinfost,
  mealRevenueStatistics,
  mealNumberStatistics,
  getdishinfosUndish,
  exportExcel,
  listUnPubBySchool,
  publishPc
};
